export enum RoutePath {
  NewOrder = "/newOrder",
  EditOrder = "/editOrder",
  SplitOrder = "/splitOrder",
  ConfirmQuantities = "/confirmQuantities",
  ConfirmDeliveryDate = "/confirmDeliveryDate",
  BookTimeSlot = "/bookTimeSlot",
  Deliveries = "/deliveries",
  Delivery = "/delivery",
  Home = "/home",
}
